const { resultWordRange, WORD_COLORS } = require('./resultWordRanges');
function pastel(hex, strength = 0.24) {
  const rgb = [1, 3, 5].map(start => parseInt(hex.slice(start, start + 2), 16));
  return `rgb(${rgb.map(c => Math.round(255 + (c - 255) * strength)).join(', ')})`;
}
function resultWordBands(words, size, selectedIndex = null) {
  const bands = words.map((word, index) => ({ index, range: resultWordRange(word, size), color: WORD_COLORS[index % WORD_COLORS.length] }))
    .filter(band => band.range).map(band => Object.assign({}, band, { horizontal: band.range.top === band.range.bottom,
      fill: pastel(band.color, selectedIndex == null || selectedIndex === band.index ? 0.27 : 0.08) }));
  const intersections = [];
  for (const row of bands.filter(b => b.horizontal)) for (const col of bands.filter(b => !b.horizontal)) {
    const r = row.range.top, c = col.range.left;
    if (c >= row.range.left && c <= row.range.right && r >= col.range.top && r <= col.range.bottom) {
      intersections.push({ row: r, col: c, horizontal: row, vertical: col });
    }
  }
  return { bands, intersections };
}
module.exports = { resultWordBands, pastel };
